export default "__VITE_ASSET__C0dHy60F__"